import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { postHistoricalMeterRequest } from "services/ConfigServices";
import { historicalData } from "variables/lists/meters";
import { metershistoricalpagetext } from "variables/meters";
import 'moment/locale/fr';
import {
  CustomSelect,
  DateInput,
} from "components/Input/Index.js";


const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "2rem",
    width: "63ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "2rem",
    width: "63ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;



function HistoricDataDialog(props) {
  const { closeModal, refetch, meter, energy, meters } = props;
  const [type, setType] = useState("");
  const [datebegin, setDatebegin] = useState(moment().subtract(1, 'month').format("YYYY-MM-DD"));
  const [dateend, setDateend] = useState(moment().format("YYYY-MM-DD"));
  const [filtereddatachoicedata, setFiltereddatachoicedata] = useState([]);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const classes = useStyles();


  const handleTypeChange = (event) => {
    setType(event.target.value);
  };
  const handleDatebeginChange = (event) => {
    let beginmin = moment().subtract(2, 'year');
    let beginmax = moment();
    let newdatebegin = event.target.value;
    if (moment(newdatebegin).isBefore(beginmin))
      newdatebegin = beginmin.format("YYYY-MM-DD");
    else if (moment(newdatebegin).isAfter(beginmax))
      newdatebegin = beginmax.format("YYYY-MM-DD");
    if (moment(newdatebegin).isAfter(moment(dateend)))
      setDateend(newdatebegin);
    setDatebegin(newdatebegin);
  };
  const handleDateendChange = (event) => {
    let endmin = moment().subtract(2, 'year');
    let endmax = moment();
    let newdateend = event.target.value;
    if (moment(newdateend).isBefore(endmin))
      newdateend = endmin.format("YYYY-MM-DD");
    else if (moment(newdateend).isAfter(endmax))
      newdateend = endmax.format("YYYY-MM-DD");
    if (moment(newdateend).isBefore(moment(datebegin)))
      setDatebegin(newdateend);
    setDateend(newdateend);
  };

  useEffect(() => {
    if (type && datebegin && moment(datebegin).isValid() && dateend && moment(dateend).isValid())
      setButtonDisabled(false);
    else
      setButtonDisabled(true);
  }, [datebegin, dateend, type]);

  const handleSubmit = async (event) => {
    if (meter) {
      axios
        .post(
          postHistoricalMeterRequest(meter.id, type, datebegin, dateend),
          {
          },
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              'Content-Type': "application/json; charset=utf-8",
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            setNotification("success", "Demande d'historique créée");
            closeModal();
            refetch();
          }
          else
            setNotification("error", "Une erreur est survenue");
        })
        .catch((error) => {
          setNotification("error", "Une erreur est survenue");
        });
    }
    else if (meters && meters.length > 0) {
      let metersid = meters.map((meter)=>meter.id);
      axios
      .post(
        postHistoricalMeterRequest("bulk", type, datebegin, dateend),
        {
          metersid
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Demande d'historique créée");
          closeModal();
          refetch();
        }
        else
          setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
    }

  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  useEffect(() => {
    if (energy) {
      let tmpdatachoicedata = historicalData[energy]
      setFiltereddatachoicedata(tmpdatachoicedata);
    }
  }, [energy]);

  return (
    <>
      <form className={classes.root}>
        {(meter || meters) &&
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <div>
                <CustomSelect
                  inputTitle={metershistoricalpagetext.type}
                  selectValue={type}
                  handleSelectValueChange={handleTypeChange}
                  data={filtereddatachoicedata}
                  isRequired={true}
                />
              </div>
            </GridItem>
            {
              !(type === 'monthly' && energy === 'electricity') ?
                <>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <div>
                      <DateInput
                        inputTitle={metershistoricalpagetext.datebegin}
                        dateInput={datebegin}
                        handleDateInputChange={handleDatebeginChange}
                        isRequired={true}
                      />
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <div>
                      <DateInput
                        inputTitle={metershistoricalpagetext.dateend}
                        dateInput={dateend}
                        handleDateInputChange={handleDateendChange}
                        isRequired={true}
                      />
                    </div>
                  </GridItem>
                </> :
                <></>
            }

          </GridContainer>}
        <Button
          disabled={buttonDisabled}
          className={buttonDisabled ? classes.submitButtonDisabled : classes.submitButton}
          onClick={() => {
            handleSubmit();
          }}
        >
          Envoyer
        </Button>

      </form>
    </>
  );
}

export default HistoricDataDialog;
